import { saveToLS, getFromLS } from './localStore';
import { v4 as uuidv4 } from 'uuid';

const manageClientId = () => {
    let clientId = getFromLS('clientId');

    if (!clientId) {
        let newClientId = uuidv4();
        saveToLS('clientId', undefined, newClientId);
        return newClientId;
    }

}

export default manageClientId